import { Injectable } from '@angular/core';

import { LocalStorage, SessionStorage } from '@anjuna/core';

@Injectable({providedIn: 'root'})
export class LocalStorageService extends LocalStorage {
  constructor() {
    super();
  }
}

@Injectable({providedIn: 'root'})
export class SessionStorageService extends SessionStorage {
  constructor() {
    super();
  }
}
